import React, {useState, useEffect} from "react";
import { useAPIs } from "../apis/APIsConfig";
import { isAffiliate } from "../services/affiliate";

import { useForm } from "../utils/hooks";
import InputMask from "react-input-mask";
import WithMainLayout from "../hocs/layouts/MainLayout";
import axios from 'axios';

const AffiliateConsultation = () => {


  useAPIs();

  const [formState, setError, changeHandler, reset] = useForm({
    Cedula: "",
  });

  const [afiliado, setAfiliado] = useState<boolean>(false);
  const [cantMaxConsulta, setCantMaxConsulta] = useState<boolean>(false);
  const [showMessage, setShowMessage] = useState<boolean>(false);
  

  function disableButton() {
    return formState.data.Cedula.replaceAll("_", "").length !== 11;
  }

  function submitForm() {
     isAffiliate(formState.data.Cedula).then((res) => {
      
      if (res) {
        setShowMessage(true);
        if (res.data.value != null && res.data.value.esAfiliado) {
          setAfiliado(true);
          setCantMaxConsulta(false)
        } else  if (res.data.value == null && res.data.message[0].code == 65) {
          setCantMaxConsulta(true)
        }else{
          setAfiliado(false);
          setCantMaxConsulta(false)
        }
      }
    });
  }


  return (
    <section className="content-consultation-deceased-affiliate">
      <div className="container">
        <div className="description">
          <div
            className="title wow fadeInUp"
            data-wow-duration="1.5s"
            data-wow-delay="0.4s"
          >
            <p>
              Utiliza esta consulta para verificar si actualmente estás afiliado
              con nosotros. Por favor digita tu número de cédula de identidad.
            </p>
          </div>
          {!showMessage && (
            <form
              onSubmit={(e) => {
                e.preventDefault();
              }}
              className="form-deceased-affiliate wow fadeInUp"
              data-wow-duration="1.5s"
              data-wow-delay="0.5s"
            >
              <div className="form-group">
                <label>Documento de Identidad</label>
                <InputMask
                  type="text"
                  className="form-control large"
                  placeholder="Ingresa tu documento"
                  value={formState.data.Cedula}
                  onChange={changeHandler("Cedula", undefined, "-")}
                  mask="999-9999999-9"
                  maskPlaceholder={"_"}
                />
                <small>&nbsp;</small>
              </div>
              <button
                type="button"
                onClick={submitForm}
                disabled={disableButton()}
                className="btn btn-primary btn-large w-full md:w-auto"
              >
                Consultar
              </button>
            </form>
          )}
          {showMessage && (
            <div className="deceased-member-information">
              <div className="title-member">
                <h5>Información del Afiliado</h5>
                <button
                  className="btn btn-secondary btn-medium md:btn-large"
                  onClick={() => {
                    setShowMessage(false);
                  }}
                >
                  <i className="icon icon-arrow-left right"></i>Consultar
                </button>
              </div>
              <div>
                {cantMaxConsulta  && <span>Lo sentimos, ha excedido el límite diario de consultas.</span>}
                {afiliado && !cantMaxConsulta  && <span>Estás afiliado</span>}
                {!afiliado && !cantMaxConsulta  && <span>No estás afiliado </span>}
                {!afiliado && !cantMaxConsulta  && <a onClick={submitForm} target="_blank"  href="https://afpcrecer.com.do/mis-beneficios/solicitud-de-afiliacion/"
                className="btn btn-primary btn-large w-full md:w-auto">
                Quiero Afiliarme
              </a>}

              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default WithMainLayout(AffiliateConsultation);
